/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressDtoFromJSON, AddressDtoToJSON, } from './';
export function CollectorAdministratorDtoFromJSON(json) {
    return CollectorAdministratorDtoFromJSONTyped(json, false);
}
export function CollectorAdministratorDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'applicationUserId': !exists(json, 'applicationUserId') ? undefined : json['applicationUserId'],
        'carCollectionId': !exists(json, 'carCollectionId') ? undefined : json['carCollectionId'],
        'addresses': !exists(json, 'addresses') ? undefined : (json['addresses'] === null ? null : json['addresses'].map(AddressDtoFromJSON)),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'additionalEmail': !exists(json, 'additionalEmail') ? undefined : json['additionalEmail'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'phoneNumberPrefix': !exists(json, 'phoneNumberPrefix') ? undefined : json['phoneNumberPrefix'],
        'additionalPhone': !exists(json, 'additionalPhone') ? undefined : json['additionalPhone'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'accountExpiresOn': !exists(json, 'accountExpiresOn') ? undefined : (json['accountExpiresOn'] === null ? null : new Date(json['accountExpiresOn'])),
    };
}
export function CollectorAdministratorDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'applicationUserId': value.applicationUserId,
        'carCollectionId': value.carCollectionId,
        'addresses': value.addresses === undefined ? undefined : (value.addresses === null ? null : value.addresses.map(AddressDtoToJSON)),
        'email': value.email,
        'additionalEmail': value.additionalEmail,
        'phone': value.phone,
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'additionalPhone': value.additionalPhone,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'accountExpiresOn': value.accountExpiresOn === undefined ? undefined : (value.accountExpiresOn === null ? null : value.accountExpiresOn.toISOString()),
    };
}
